import { initialLanguageState, ILanguageState } from '../state/language.state';
import { LanguagesActions, ELanguagestActions } from '../actions/languages.actiosn';

export const languagesReducers = (
    state = initialLanguageState,
    action: LanguagesActions
  ): ILanguageState => {
    switch (action.type) {
      case ELanguagestActions.GetLanguagesSuccess: {
        return {
          ...state,
          languages: action.payload
        };
      }
      default:
        return state;
    }
  };
